module.exports = __webpack_public_path__ + "img/Mercedes.29969645.png";